import { render, staticRenderFns } from "./PSearchSort.vue?vue&type=template&id=78f0ef2a&scoped=true&"
import script from "./PSearchSort.vue?vue&type=script&lang=ts&"
export * from "./PSearchSort.vue?vue&type=script&lang=ts&"
import style0 from "./PSearchSort.vue?vue&type=style&index=0&id=78f0ef2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f0ef2a",
  null
  
)

export default component.exports